import PubSub from "underpub-js";

var PopupUnit = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-PopupUnit',
	};

	$.extend(true, this.options, options);

};

PopupUnit.prototype.init = function() {

	var self = this;

	//hide the column "Floor" if it's all empty
	self.$columnFloorHeading = self.options.$el.find(`.${self.options.baseClass}__column_floor_heading`);
	self.$columnFloor = self.options.$el.find(`.${self.options.baseClass}__column_floor`);
	const allEmpty = self.$columnFloor.toArray().every(el => {
		const text = $(el).text().trim();
		return text === "" || text === "-";
	});
	if (allEmpty) {
		self.$columnFloor.hide();
		self.$columnFloorHeading.hide();
	} else {
		self.$columnFloor.show();
		self.$columnFloorHeading.show();
	}
};

export default PopupUnit;
